export default __webpack_public_path__ + "static/media/CBEX_light_logo_centered.5602e86c.png";